import React, { useState } from "react";
import {
  Modal,
  Input,
  Button,
  Spin,
} from "antd";
import { LockOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";

import api from "../../../../api/api";

import RoyaltyPurchaseReceipt from "./RoyaltyPurchaseReceipt";


const RoyaltyCardPayment = ({
  open,
  onClose,
  purchaseItems = [],
  total = 0,
  selectedYear,
  formatNumber,
  resetCart,
}) => {

  // =========================================================
  // PIN
  // =========================================================

  const [pin, setPin] = useState("");

  // =========================================================
  // LOADING
  // =========================================================

  const [loading, setLoading] =
    useState(false);

  // =========================================================
  // RECEIPT
  // =========================================================

  const [receiptOpen, setReceiptOpen] =
    useState(false);

  const [receiptData, setReceiptData] =
    useState([]);

  const [receiptTotal, setReceiptTotal] =
    useState(0);

  const [receiptCustomer, setReceiptCustomer] =
    useState(null);

  const [balanceBefore, setBalanceBefore] =
    useState(0);

  const [balanceAfter, setBalanceAfter] =
    useState(0);


  // =========================================================
  // HANDLE ROYALTY PAYMENT
  // =========================================================

  const handleRoyaltyPayment = async () => {

    // =======================================================
    // PIN VALIDATION
    // =======================================================

    if (!/^\d{4}$/.test(pin)) {

      Swal.fire({
        icon: "warning",
        title: "Invalid PIN",
        text:
          "Please enter a valid 4-digit card PIN.",
        confirmButtonText: "OK",
        confirmButtonColor: "#2575fc",
      });

      return;
    }


    // =======================================================
    // CART VALIDATION
    // =======================================================

    if (!purchaseItems?.length) {

      Swal.fire({
        icon: "warning",
        title: "Empty Cart",
        text:
          "There are no items in the cart.",
        confirmButtonText: "OK",
        confirmButtonColor: "#2575fc",
      });

      return;
    }


    setLoading(true);


    try {

      // =====================================================
      // BUILD CLEAN ITEMS
      // =====================================================

      const items =
        purchaseItems.map((item) => {

          return {
            product:
              item.product ??
              item.product_id ??
              item.id,

            quantity_taken:
              Number(
                item.quantity_taken ??
                item.quantity ??
                1
              ),
          };
        });


      // =====================================================
      // VALIDATE ITEMS
      // =====================================================

      const invalidItem =
        items.find((item) => {

          return (
            !item.product ||
            Number(item.product) <= 0 ||
            !item.quantity_taken ||
            item.quantity_taken <= 0
          );
        });


      if (invalidItem) {

        Swal.fire({
          icon: "error",
          title: "Invalid Product Data",
          text:
            "One or more products have invalid data. Please review your cart and try again.",
          confirmButtonText: "OK",
          confirmButtonColor: "#d33",
        });

        setLoading(false);

        return;
      }


      // =====================================================
      // REQUEST PAYLOAD
      // =====================================================

      const payload = {

        items,

        payment_method:
          "royalty",

        card_pin:
          pin,

        year:
          selectedYear?.id ?? null,
      };


      console.log(
        "===================================="
      );

      console.log(
        "ROYALTY PURCHASE REQUEST:"
      );

      console.log(
        payload
      );

      console.log(
        "===================================="
      );


      // =====================================================
      // SEND PAYMENT
      // =====================================================

      const response =
        await api.post(
          "/api/purchases/",
          payload
        );


      console.log(
        "===================================="
      );

      console.log(
        "ROYALTY PURCHASE RESPONSE:"
      );

      console.log(
        response.data
      );

      console.log(
        "===================================="
      );


      // =====================================================
      // BACKEND PURCHASES
      // =====================================================

      const backendPurchases =
        Array.isArray(
          response.data?.purchases
        )
          ? response.data.purchases
          : [];


      console.log(
        "BACKEND PURCHASE ITEMS:",
        backendPurchases
      );


      // =====================================================
      // NORMALIZE RECEIPT ITEMS
      //
      // Backend serializer should return:
      //
      // product_name
      // price
      // quantity_taken
      // total
      //
      // =====================================================

      let normalizedItems = [];


      if (
        backendPurchases.length > 0
      ) {

        normalizedItems =
          backendPurchases.map(
            (item) => {

              // ===========================================
              // PRODUCT NAME
              // ===========================================

              const productName =
                item?.product_name ||
                item?.product?.name ||
                item?.name ||
                "Product";


              // ===========================================
              // QUANTITY
              // ===========================================

              const quantity =
                Number(
                  item?.quantity_taken ??
                  item?.quantity ??
                  item?.qty ??
                  1
                );


              // ===========================================
              // UNIT PRICE
              //
              // Backend now returns:
              //
              // price
              //
              // ===========================================

              const price =
                Number(
                  item?.price ??
                  item?.unit_price ??
                  item?.product?.price ??
                  0
                );


              // ===========================================
              // TOTAL
              //
              // Backend now returns:
              //
              // total
              //
              // ===========================================

              const backendItemTotal =
                Number(
                  item?.total ??
                  item?.revenue ??
                  item?.line_total ??
                  0
                );


              // ===========================================
              // FALLBACK CALCULATION
              // ===========================================

              const calculatedItemTotal =
                price * quantity;


              const itemTotal =
                backendItemTotal > 0
                  ? backendItemTotal
                  : calculatedItemTotal;


              console.log(
                "ROYALTY RECEIPT ITEM:",
                {
                  original: item,

                  product_name:
                    productName,

                  quantity_taken:
                    quantity,

                  price:
                    price,

                  backend_total:
                    backendItemTotal,

                  calculated_total:
                    calculatedItemTotal,

                  final_total:
                    itemTotal,
                }
              );


              return {

                id:
                  item?.id,

                product:
                  item?.product,

                product_name:
                  productName,

                quantity_taken:
                  Number.isFinite(quantity) &&
                  quantity > 0
                    ? quantity
                    : 1,

                price:
                  Number.isFinite(price)
                    ? price
                    : 0,

                total:
                  Number.isFinite(itemTotal)
                    ? itemTotal
                    : 0,
              };
            }
          );

      } else {

        // =================================================
        // FALLBACK TO ORIGINAL CART
        // =================================================

        normalizedItems =
          purchaseItems.map(
            (item) => {

              const quantity =
                Number(
                  item?.quantity_taken ??
                  item?.quantity ??
                  item?.qty ??
                  1
                );


              const price =
                Number(
                  item?.price ??
                  item?.unit_price ??
                  item?.product_price ??
                  item?.selling_price ??
                  item?.sale_price ??
                  item?.product?.price ??
                  0
                );


              const existingTotal =
                Number(
                  item?.total ??
                  item?.line_total ??
                  item?.subtotal ??
                  item?.total_amount ??
                  0
                );


              const calculatedTotal =
                price * quantity;


              const itemTotal =
                existingTotal > 0
                  ? existingTotal
                  : calculatedTotal;


              return {

                id:
                  item?.id,

                product:
                  item?.product ??
                  item?.product_id,

                product_name:
                  item?.product_name ||
                  item?.name ||
                  item?.product?.name ||
                  "Product",

                quantity_taken:
                  Number.isFinite(quantity) &&
                  quantity > 0
                    ? quantity
                    : 1,

                price:
                  Number.isFinite(price)
                    ? price
                    : 0,

                total:
                  Number.isFinite(itemTotal)
                    ? itemTotal
                    : 0,
              };
            }
          );
      }


      // =====================================================
      // LOG FINAL RECEIPT DATA
      // =====================================================

      console.log(
        "===================================="
      );

      console.log(
        "FINAL ROYALTY RECEIPT DATA:"
      );

      console.log(
        normalizedItems
      );

      console.log(
        "===================================="
      );


      // =====================================================
      // CALCULATE TOTAL FROM RECEIPT ITEMS
      // =====================================================

      const calculatedTotal =
        normalizedItems.reduce(
          (
            sum,
            item
          ) => {

            return (
              sum +
              Number(
                item?.total || 0
              )
            );
          },
          0
        );


      // =====================================================
      // BACKEND TOTAL
      //
      // Your backend now returns:
      //
      // cart_total
      // total
      //
      // =====================================================

      const backendTotal =
        Number(
          response.data?.total ??
          response.data?.cart_total ??
          response.data?.total_amount ??
          response.data?.amount ??
          0
        );


      // =====================================================
      // FINAL TOTAL
      //
      // Priority:
      //
      // 1. Backend total
      // 2. Calculated item total
      // 3. Original cart total
      //
      // =====================================================

      let finalTotal = 0;


      if (
        Number.isFinite(
          backendTotal
        ) &&
        backendTotal > 0
      ) {

        finalTotal =
          backendTotal;

      } else if (
        calculatedTotal > 0
      ) {

        finalTotal =
          calculatedTotal;

      } else {

        finalTotal =
          Number(total || 0);
      }


      console.log(
        "BACKEND TOTAL:",
        backendTotal
      );

      console.log(
        "CALCULATED TOTAL:",
        calculatedTotal
      );

      console.log(
        "FINAL ROYALTY RECEIPT TOTAL:",
        finalTotal
      );


      // =====================================================
      // CUSTOMER
      // =====================================================

      setReceiptCustomer(
        response.data?.customer ||
        null
      );


      // =====================================================
      // BALANCE BEFORE
      // =====================================================

      setBalanceBefore(
        Number(
          response.data?.balance_before ??
          0
        )
      );


      // =====================================================
      // BALANCE AFTER
      // =====================================================

      setBalanceAfter(
        Number(
          response.data?.balance_after ??
          0
        )
      );


      // =====================================================
      // RECEIPT ITEMS
      // =====================================================

      setReceiptData(
        normalizedItems
      );


      // =====================================================
      // RECEIPT TOTAL
      // =====================================================

      setReceiptTotal(
        finalTotal
      );


      // =====================================================
      // SUCCESS MESSAGE
      // =====================================================

      await Swal.fire({

        icon: "success",

        title:
          "Payment Successful!",

        text:
          "Your royalty card payment has been completed successfully.",

        confirmButtonText:
          "View Receipt",

        confirmButtonColor:
          "#2575fc",

        allowOutsideClick:
          false,

        allowEscapeKey:
          false,
      });


      // =====================================================
      // CLEAR PIN
      // =====================================================

      setPin("");


      // =====================================================
      // CLOSE ROYALTY PAYMENT MODAL
      // =====================================================

      onClose();


      // =====================================================
      // CLEAR CART
      //
      // resetCart closes the payment modal/cart.
      // It does NOT affect receiptOpen.
      // =====================================================

      resetCart();


      // =====================================================
      // OPEN RECEIPT
      // =====================================================

      setReceiptOpen(true);


    } catch (error) {

      // =====================================================
      // ERROR LOG
      // =====================================================

      console.error(
        "ROYALTY PAYMENT ERROR:",
        error
      );

      console.error(
        "ROYALTY BACKEND ERROR:",
        error.response?.data
      );


      // =====================================================
      // ERROR MESSAGE
      // =====================================================

      let errorMessage =
        error.response?.data?.error ||
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Royalty payment failed. Please try again.";


      // =====================================================
      // DRF VALIDATION ERRORS
      // =====================================================

      if (
        typeof error.response?.data ===
          "object" &&
        !error.response?.data?.error &&
        !error.response?.data?.detail &&
        !error.response?.data?.message
      ) {

        const data =
          error.response.data;

        const messages = [];


        Object.keys(data).forEach(
          (key) => {

            const value =
              data[key];


            if (
              Array.isArray(value)
            ) {

              value.forEach(
                (message) => {

                  messages.push(
                    `${key}: ${message}`
                  );
                }
              );

            } else if (
              typeof value ===
              "string"
            ) {

              messages.push(
                `${key}: ${value}`
              );
            }
          }
        );


        if (
          messages.length > 0
        ) {

          errorMessage =
            messages.join("\n");
        }
      }


      // =====================================================
      // ERROR ALERT
      // =====================================================

      Swal.fire({

        icon: "error",

        title:
          "Payment Failed",

        text:
          errorMessage,

        confirmButtonText:
          "OK",

        confirmButtonColor:
          "#d33",
      });

    } finally {

      setLoading(false);
    }
  };


  // =========================================================
  // RENDER
  // =========================================================

  return (
    <>

      {/* =====================================================
          ROYALTY PAYMENT MODAL
      ===================================================== */}

      <Modal

        open={open}

        onCancel={onClose}

        footer={null}

        centered

        width={620}

        destroyOnClose

        bodyStyle={{
          padding: "35px",
          background: "#f8fafc",
          borderRadius: "20px",
        }}

      >

        {/* ===================================================
            HEADER
        =================================================== */}

        <div
          style={{
            textAlign: "center",
            marginBottom: 30,
          }}
        >

          <div
            style={{
              width: 80,
              height: 80,
              margin:
                "0 auto 18px",
              borderRadius: "50%",
              background:
                "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: 36,
              color: "#fff",
              boxShadow:
                "0 12px 30px rgba(37,117,252,0.3)",
            }}
          >
            👑
          </div>


          <h1
            style={{
              margin: 0,
              fontSize: 28,
              fontWeight: 800,
              color: "#1e293b",
            }}
          >
            Royalty Card Payment
          </h1>


          <p
            style={{
              marginTop: 10,
              color: "#64748b",
              fontSize: 15,
            }}
          >
            Securely complete your
            purchase using your
            royalty card.
          </p>

        </div>


        {/* ===================================================
            PIN CARD
        =================================================== */}

        <div
          style={{
            background: "#fff",
            padding: 25,
            borderRadius: 18,
            boxShadow:
              "0 8px 24px rgba(0,0,0,0.06)",
            border:
              "1px solid #e2e8f0",
          }}
        >

          <label
            style={{
              display: "block",
              marginBottom: 10,
              fontWeight: 700,
              color: "#334155",
              fontSize: 15,
            }}
          >
            Card Security PIN
          </label>


          <Input.Password

            placeholder="Enter your 4-digit card PIN"

            value={pin}

            onChange={(event) => {

              const value =
                event.target.value
                  .replace(/\D/g, "")
                  .slice(0, 4);

              setPin(value);
            }}

            prefix={
              <LockOutlined
                style={{
                  color: "#2575fc",
                  fontSize: 18,
                }}
              />
            }

            size="large"

            maxLength={4}

            inputMode="numeric"

            style={{
              height: 55,
              borderRadius: 14,
              fontSize: 18,
              fontWeight: 600,
            }}

          />


          <div
            style={{
              marginTop: 12,
              color: "#64748b",
              fontSize: 13,
            }}
          >
            🔒 Your PIN is used only
            to authorize this
            transaction.
          </div>

        </div>


        {/* ===================================================
            TOTAL CARD
        =================================================== */}

        <div
          style={{
            marginTop: 25,
            background:
              "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
            borderRadius: 18,
            padding: 25,
            color: "#fff",
            textAlign: "center",
            boxShadow:
              "0 12px 30px rgba(37,117,252,0.25)",
          }}
        >

          <div
            style={{
              fontSize: 14,
              opacity: 0.9,
              marginBottom: 8,
              letterSpacing: 1,
            }}
          >
            TOTAL AMOUNT
          </div>


          <div
            style={{
              fontSize: 36,
              fontWeight: 800,
            }}
          >

            $

            {formatNumber(
              Number(total || 0)
            )}

          </div>

        </div>


        {/* ===================================================
            PAY BUTTON
        =================================================== */}

        <Button

          block

          size="large"

          onClick={
            handleRoyaltyPayment
          }

          disabled={
            loading ||
            !/^\d{4}$/.test(pin)
          }

          style={{
            marginTop: 30,
            height: 58,
            border: "none",
            borderRadius: 18,
            background:
              "linear-gradient(135deg, #6a11cb 0%, #2575fc 100%)",
            color: "#fff",
            fontWeight: 800,
            fontSize: 18,
            letterSpacing: "0.8px",
            boxShadow:
              "0 10px 30px rgba(37,117,252,0.35)",
            transition:
              "all 0.3s ease",
          }}

          onMouseEnter={(event) => {

            if (!loading) {

              event.currentTarget.style.transform =
                "translateY(-3px)";

              event.currentTarget.style.boxShadow =
                "0 14px 35px rgba(37,117,252,0.45)";
            }
          }}

          onMouseLeave={(event) => {

            if (!loading) {

              event.currentTarget.style.transform =
                "translateY(0)";

              event.currentTarget.style.boxShadow =
                "0 10px 30px rgba(37,117,252,0.35)";
            }
          }}

        >

          {loading ? (

            <>

              <Spin
                size="small"
                style={{
                  marginRight: 10,
                }}
              />

              Processing Payment...

            </>

          ) : (

            "👑 Complete Royalty Payment"

          )}

        </Button>

      </Modal>


      {/* =====================================================
          ROYALTY PURCHASE RECEIPT
      ===================================================== */}

      <RoyaltyPurchaseReceipt

        open={receiptOpen}

        onClose={() =>
          setReceiptOpen(false)
        }

        receiptData={
          receiptData
        }

        receiptTotal={
          receiptTotal
        }

        formatNumber={
          formatNumber
        }

        receiptCustomer={
          receiptCustomer
        }

        balanceBefore={
          balanceBefore
        }

        balanceAfter={
          balanceAfter
        }

      />

    </>
  );
};


export default RoyaltyCardPayment;